import React from 'react'
import ReactHtmlParser from 'react-html-parser'
import './footer.css'
import Strings from 'utils/translations'

const Footer = ({ translation }) => (
  <footer className='footer'>
    <div className='container-fluid'>
      <div className='footer__block'>
        <h4>{Strings.footer.connect[translation.currentLang]}</h4>
        <ul>
          <li>{Strings.footer.tel}</li>
          <li>{Strings.footer.city[translation.currentLang]}</li>
          <li><a href={`mailto:${Strings.footer.email}`}>{Strings.footer.email}</a></li>
        </ul>
      </div>
      <div className='footer__block'>
        <h4>{Strings.footer.inquiries.title[translation.currentLang]}</h4>
        <p>{ReactHtmlParser(Strings.footer.inquiries.text[translation.currentLang])}</p>
      </div>
    </div>
  </footer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Page/Footer/index.js